export type DeclaredStudentRow = {
	firstName: string;
	lastName: string;
};

/** Zgodnie z FieldsConfig::STUDENTS_LENGTH (kolumna teachers.students). */
export const DECLARED_STUDENTS_MAX_CHARS = 4000;

export const emptyDeclaredStudent = (): DeclaredStudentRow => ({
	firstName: '',
	lastName: '',
});

export const serializeDeclaredStudents = (rows: DeclaredStudentRow[]): string => {
	const items = rows
		.map((r) => ({
			firstName: r.firstName.trim(),
			lastName: r.lastName.trim(),
		}))
		.filter((r) => r.firstName !== '' || r.lastName !== '');
	return JSON.stringify({ v: 1, items });
};

export const parseDeclaredStudentsForSummary = (stored: string, rows: DeclaredStudentRow[]): string => {
	const filled = rows.filter((r) => r.firstName.trim() && r.lastName.trim());
	if (filled.length > 0) {
		return filled.map((r) => `${r.firstName.trim()} ${r.lastName.trim()}`).join(', ');
	}
	return stored;
};

export const validateDeclaredStudents = (rows: DeclaredStudentRow[]): string | null => {
	const nonEmpty = rows.filter((r) => r.firstName.trim() || r.lastName.trim());
	if (nonEmpty.length === 0) {
		return 'Prosimy o podanie co najmniej jednego ucznia (imię i nazwisko).';
	}
	for (const row of nonEmpty) {
		if (!row.firstName.trim() || !row.lastName.trim()) {
			return 'Każdy uczeń musi mieć uzupełnione imię i nazwisko.';
		}
	}
	return null;
};

/** Parsuje zapis z kolumny teachers.students — JSON v1 lub legacy free-text. */
export function parseStoredToRows(stored: string): { rows: DeclaredStudentRow[]; isStructured: boolean } {
	const trimmed = (stored || '').trim();
	if (trimmed === '') {
		return { rows: [emptyDeclaredStudent()], isStructured: true };
	}
	if (trimmed.startsWith('{')) {
		try {
			const parsed = JSON.parse(trimmed) as { v?: number; items?: { firstName?: string; lastName?: string }[] };
			if (parsed?.v === 1 && Array.isArray(parsed.items)) {
				const rows = parsed.items.map((item) => ({
					firstName: String(item.firstName ?? '').trim(),
					lastName: String(item.lastName ?? '').trim(),
				}));
				return { rows: rows.length > 0 ? rows : [emptyDeclaredStudent()], isStructured: true };
			}
		} catch {
			// fall through to legacy
		}
	}
	const parts = trimmed.split(/[,;\n]+/);
	const legacyRows: DeclaredStudentRow[] = [];
	for (const part of parts) {
		const name = part.trim();
		if (name === '') continue;
		const tokens = name.split(/\s+/);
		if (tokens.length === 1) {
			legacyRows.push({ firstName: tokens[0], lastName: '' });
		} else {
			legacyRows.push({ firstName: tokens[0], lastName: tokens.slice(1).join(' ') });
		}
	}
	return { rows: legacyRows.length > 0 ? legacyRows : [emptyDeclaredStudent()], isStructured: false };
}
